import React from 'react';
import { Clock3Icon, SparklesIcon, UsersIcon } from 'lucide-react';
import { LocalizedContent } from '../../data/siteContent';
type Props = {
  chapterId: string;
  content: LocalizedContent;
};
export function ActivityBrief({
  chapterId,
  content
}: Props) {
  const profile = content.activityProfiles[chapterId];
  if (!profile) return null;
  return <div className="mt-4 grid max-w-2xl grid-cols-1 gap-x-4 gap-y-2 border-y border-white/15 py-3 text-left sm:mt-5 sm:flex sm:flex-wrap sm:gap-x-5 sm:gap-y-3 sm:py-3.5" aria-label={content.activity.ariaLabel} data-id="element-21" data-mp="r6ncoumul9hn">
      <div className="flex min-w-0 items-center gap-2" data-id="element-22" data-mp="i9mq8tjc9lgu">
        <Clock3Icon className="h-3.5 w-3.5 text-[var(--ms-gold-soft)]" data-id="element-23" data-mp="3k8exfw7ctyt" />
        <span className="text-[10px] uppercase tracking-[0.16em] text-white/50" data-id="element-24" data-mp="8hh0lqgk7g4t">{content.activity.paceLabel}</span>
        <span className="text-xs text-white/90" data-id="element-25" data-mp="3qoo9lt4fcr5i">{profile.duration}</span>
      </div>
      <div className="flex min-w-0 items-center gap-2" data-id="element-26" data-mp="3upq98b297580">
        <SparklesIcon className="h-3.5 w-3.5 text-[var(--ms-gold-soft)]" data-id="element-27" data-mp="3urb4y40b0u7g" />
        <span className="text-[10px] uppercase tracking-[0.16em] text-white/50" data-id="element-28" data-mp="1y0h3xlp40gt">{content.activity.feelLabel}</span>
        <span className="text-xs text-white/90" data-id="element-29" data-mp="3t5cxiaer89vo">{profile.difficulty}</span>
      </div>
      <div className="flex min-w-0 items-center gap-2" data-id="element-30" data-mp="bwzdagp9y3mx">
        <UsersIcon className="h-3.5 w-3.5 text-[var(--ms-gold-soft)]" data-id="element-31" data-mp="6xv4hr69i7x4" />
        <span className="text-[10px] uppercase tracking-[0.16em] text-white/50" data-id="element-32" data-mp="6wk1htkn5472">{content.activity.bestForLabel}</span>
        <span className="text-xs text-white/90" data-id="element-33" data-mp="3afdaru6dz6vf">{profile.idealFor}</span>
      </div>
      <p className="border-t border-white/10 pt-2 text-[11px] leading-relaxed text-white/65 sm:basis-full sm:pt-3 sm:text-xs" data-id="element-34" data-mp="3adabskn9a3ek">
        <span className="font-medium text-[var(--ms-gold-soft)]" data-id="element-35" data-mp="3kcrequb4i36u">{content.activity.careLabel}</span> {content.activity.careText}
      </p>
    </div>;
}